import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, switchMap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { SecureChangeHttpClient } from './secure-change-http-client';
import { SecureChangeActions } from './secure-change.store';

@Injectable({ providedIn: 'root' })
export class SecureChangeEffects {
  private readonly actions$ = inject(Actions);
  private readonly secureChangeHttpClient = inject(SecureChangeHttpClient);

  public fetch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SecureChangeActions.fetch),
      switchMap(({ payload }) =>
        this.secureChangeHttpClient.fetchToken(payload.params, payload.skipCompany).pipe(
          map(data => SecureChangeActions.fetchSuccess({ payload: data })),
          catchError(error => of(SecureChangeActions.fetchFailed({ payload: error }))),
        ),
      ),
    ),
  );

  public requestEmailCode$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SecureChangeActions.requestEmailCode),
      switchMap(() =>
        this.secureChangeHttpClient.requestEmailCode().pipe(
          map(data => SecureChangeActions.requestEmailCodeSuccess()),
          catchError(error => of(SecureChangeActions.requestEmailCodeFailed({ payload: error }))),
        ),
      ),
    ),
  );
}
